export const FETCH_ROLES_STARTED = 'FETCH_ROLES_STARTED' as const;
export const FETCH_ROLES_FULFILLED = 'FETCH_ROLES_FULFILLED' as const;

export const fetchRoles = () => ({ type: FETCH_ROLES_STARTED });

export const fetchRolesFulfilled = (data: unknown) => ({ type: FETCH_ROLES_FULFILLED, payload: data });
